import React, { useState } from 'react';
import './AdvancedTaxiFilter.css';

const AdvancedTaxiFilter = ({ onFilterChange }) => {
  const [minKm, setMinKm] = useState('');
  const [maxKm, setMaxKm] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [manufacturer, setManufacturer] = useState('');

  const handleFilterChange = () => {
    onFilterChange({ minKm, maxKm, minPrice, maxPrice, manufacturer });
  };

  return (
    <div className="filter-container">
      <div className="filter-section">
<div className="filter-group">
  <label>יצרן</label>
  <select
    value={manufacturer}
    onChange={e => setManufacturer(e.target.value)}
  >
    <option value="">הכל</option>
    <option value="מרצדס">מרצדס</option>
    <option value="סקודה">סקודה</option>
    <option value="טויוטה">טויוטה</option>
    <option value="יונדאי">יונדאי</option>
    <option value="קיה">קיה</option>
    <option value="שברולט">שברולט</option>
    <option value="פולקסווגן">פולקסווגן</option>
    <option value="פורד">פורד</option>
    <option value="פיג'ו">פיג'ו</option>
    <option value="רנו">רנו</option>
    <option value="ניסאן">ניסאן</option>
    <option value="מיצובישי">מיצובישי</option>
    <option value="אופל">אופל</option>
    <option value="דאצ'יה">דאצ'יה</option>
    <option value="סיאט">סיאט</option>
    <option value="הונדה">הונדה</option>
    <option value="סיטרואן">סיטרואן</option>
    <option value="MG">MG</option>
    <option value="ג'ילי">ג'ילי</option>
    <option value="טסלה">טסלה</option>
    <option value="סאניאנג">סאניאנג</option>
  </select>
</div>

        <div className="filter-group">
          <label>ק״מ מינימלי</label>
          <input
            type="number"
            value={minKm}
            onChange={e => setMinKm(e.target.value)}
            placeholder="לדוג׳ 0"
          />
        </div>
        <div className="filter-group">
          <label>ק״מ מקסימלי</label>
          <input
            type="number"
            value={maxKm}
            onChange={e => setMaxKm(e.target.value)}
            placeholder="לדוג׳ 250,000"
          />
        </div>
        <div className="filter-group">
          <label>מחיר מינימלי</label>
          <input
            type="number"
            value={minPrice}
            onChange={e => setMinPrice(e.target.value)}
            placeholder="לדוג׳ 10,000"
          />
        </div>
        <div className="filter-group">
          <label>מחיר מקסימלי</label>
          <input
            type="number"
            value={maxPrice}
            onChange={e => setMaxPrice(e.target.value)}
            placeholder="לדוג׳ 200,000"
          />
        </div>
        <div className="filter-group filter-button-group">
          <button onClick={handleFilterChange}>🔍 חפש עכשיו</button>
        </div>
      </div>
    </div>
  );
};

export default AdvancedTaxiFilter;
